// extracted by mini-css-extract-plugin
export default {"dialog":"ReleaseNotesDialog_dialog__66LSf","dialog-title":"ReleaseNotesDialog_dialog-title__7JVcB","dialog-content":"ReleaseNotesDialog_dialog-content__1XszW"};